var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('h1',[_vm._v("PAGE NOT FOUND")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }